/* Component Dependencies */
var erfpAttachmentTemplate = require('templates/erfpAttachment.hbs');
var AriesComponent = require('libs/aries-component');
var Config = require('group_libs/config');
var templateUploadedFileList = require('templates/partials/uploadedFile.hbs');

AriesComponent.create({
  type: 'erfpAttachment',
  template: {
    'erfpAttachment': erfpAttachmentTemplate
  },
  events: { 
    'change .js-add-attachments' : 'uploadFile',
    'click .js-uploaded-file-list li' : 'fileUploadAdditionInfo',
    'blur .js-file-additional-info' : 'sendCommentsDataForSubmit',
    'click .js-remove-file' : 'removeAttachment'
  },
  errorMessages : {
    fileTypeError : null,
    fileSizeError : null,
    fileMalwareError : null
  },
  formData :[],
  bindEvents: function() {
    var _self = this, uploadEle = this.$el.find('.js-add-attachments');
    Config.ERFP_ATTACHMENT.fileTypes = uploadEle.data('filetypes').split(',') || Config.ERFP_ATTACHMENT.fileTypes;
    Config.ERFP_ATTACHMENT.fileCount = uploadEle.data('filecount') || Config.ERFP_ATTACHMENT.fileCount;
    Config.ERFP_ATTACHMENT.maxSize = uploadEle.data('maxsize') || Config.ERFP_ATTACHMENT.maxSize;
    Config.ERFP_ATTACHMENT.unit = uploadEle.data('unit').toLowerCase() || Config.ERFP_ATTACHMENT.unit;
    Config.ERFP_ATTACHMENT.uploadedFilesSizeInBytes = _self.$el.data('uploadedfilesize') || Config.ERFP_ATTACHMENT.uploadedFilesSizeInBytes;
    Config.ERFP_ATTACHMENT.uploadedFilesCount = _self.$el.data('totalfilesuploaded') || Config.ERFP_ATTACHMENT.uploadedFilesCount;
    _self.errorMessages.fileTypeError = _self.$el.data('filetypeerror');
    _self.errorMessages.fileSizeError = _self.$el.data('filesizeerror');
    _self.errorMessages.fileMalwareError = _self.$el.data('filemalwareerror');

    _self.disableFileUploadBttn();
    _self.calculateMaxSizeInBytes();
    _self.setDefaultData();
    _self.handleTabIndex();
    if(_self.$el.data('isQuickGroupReviewFlag')) {
      _self.reviewPageAttachment();
    }
    _self.$el.find('.l-attach-file-bttn').on( 'keyup', _.bind(_self.handleEnterOnLabel, this));
    $(document).ready(function() {
      _self.pubsub.publish('UPDATE_FORM_DATA', ['attachmentDetails', _self.formData]);
    });
  },
  setDefaultData: function _setDefaultData() {
    var _self = this;
    _self.formData = [];
    this.$el.find('.js-file-additional-info').each(function() {
      _self.fetchData(null, $(this));
    });
  },

  /**
  * This method will calculate no of attachments.
  * Will run on review page
  */
  reviewPageAttachment: function _reviewPageAttachment() {
    var _self = this;
    var totalFilesAttached = _self.$el.find('.js-uploaded-file-list li').length;
    _self.$el.find('.t-attachment-info').text(': ' + totalFilesAttached);
    if(totalFilesAttached > 0) {
      _self.$el.addClass('l-display-block').removeClass('l-display-none');
    }
    else {
      _self.$el.addClass('l-display-none').removeClass('l-display-block');
    }
  },

  /**
   * This method will validate file and upload to the server.
   * @event {object} event object of file change event.
   */
  uploadFile : function _uploadFile(e) {
    e.stopPropagation();
    var _self = this, target = e.target,
    isTypeError = true,
    isSizeAndCountError = true,
    formData,
    endpointURL = $(target).data('endpoint');

    isTypeError = _self.checkFileType(target.files[0].name);
    if(isTypeError){
      _self.showFileErrorMessage('fileTypeError');
      return false;
    }

    isSizeAndCountError = _self.checkTotalUploadSizeAndFilesCount(target.files[0].size);
    if(isSizeAndCountError){
      _self.showFileErrorMessage('fileSizeError');
      return false;
    }
    
    formData = new FormData();
    formData.append('erfpAttachment', target.files[0]);
    
    _self.hideErrorMessage();
    $(target).attr('disabled', true);
    $(target).prev().addClass('is-disabled');
    _self.makeAjaxCall({
      url: endpointURL,
      method: 'POST',
      data: formData,
      contentType: false,
      processData: false,
      success: _.bind(_self.fileUploadSuccessCallback, _self),
      error : function (e) {
        console.error(e);
        $(target).removeAttr('disabled');
        $(target).prev().removeClass('is-disabled');
      }
    });
  },
  /**
   * This method is success callback of file upload.
   * @param {object} ajax response object.
   */
  fileUploadSuccessCallback : function _fileUploadSuccessCallback(response) {
    var _self = this, uploadEle = _self.$el.find('.js-add-attachments');
    if(response.isError === true) {
      _self.showFileErrorMessage(response.errorMessages);
    }else{
      Config.ERFP_ATTACHMENT.uploadedFilesCount = response.totalFilesUploaded;
      Config.ERFP_ATTACHMENT.uploadedFilesSizeInBytes = response.totalFilesSize;
      _self.$el.find('.js-total-file-size').text(response.totalFileSizeLabel);
      _self.addNewFileRow(response);
      _self.setDefaultData();
      _self.enableContactInfoCTA = true;
      if(_self.$el.data('isQuickGroupReviewFlag')) {
        _self.reviewPageAttachment();
      }
      _self.pubsub.publish('SHOW_SKIP_TO_CONTACT_CTA', [{show: _self.enableContactInfoCTA}]);
      _self.pubsub.publish('UPDATE_EVENT_SUMMARY',['attachmentDetails',{"totalFilesUploaded":response.totalFilesUploaded}])
    }
    uploadEle.removeAttr('disabled').val('');
    uploadEle.prev().removeClass('is-disabled');
    _self.disableFileUploadBttn();
  },
  /**
   * This method will check for valid file types that can be uploaded to the server.
   * @param {string} it expects file name as a prameter.
   */
  checkFileType : function _checkFileType(fileName){
    var _self = this, ext = fileName.match(/\.([^\.]+)$/)[1];
    return Config.ERFP_ATTACHMENT.fileTypes.indexOf(ext) > -1 ? false : true;
  },

  /**
   * This method will check for file size and number of files that can be uploaded to the server.
   * @param {string} it expects file size as a prameter.
   */
  checkTotalUploadSizeAndFilesCount : function _checkTotalUploadSizeAndFilesCount(size) {
    var _self = this, currentSize = Config.ERFP_ATTACHMENT.uploadedFilesSizeInBytes;
    Config.ERFP_ATTACHMENT.uploadedFilesSizeInBytes += size;
    if(Config.ERFP_ATTACHMENT.uploadedFilesSizeInBytes <= Config.ERFP_ATTACHMENT.maxSizeInBytes){
      if(Config.ERFP_ATTACHMENT.uploadedFilesCount <= Config.ERFP_ATTACHMENT.fileCount){
        _self.disableFileUploadBttn();
        return false;
      }
    }
    Config.ERFP_ATTACHMENT.uploadedFilesSizeInBytes = currentSize;
    return true;
  },
  /**
   * This method will calculate the maximum nuber of bytes that can be uploaded to the server.
   */
  calculateMaxSizeInBytes : function _calculateMaxSizeInBytes () {
    var _self = this;
    switch(Config.ERFP_ATTACHMENT.unit){
      case 'bytes' : 
        Config.ERFP_ATTACHMENT.maxSizeInBytes = Config.ERFP_ATTACHMENT.maxSize;
        break;
      case 'kb' : 
        Config.ERFP_ATTACHMENT.maxSizeInBytes = Config.ERFP_ATTACHMENT.maxSize * 1024;
        break;
      case 'mb' : 
        Config.ERFP_ATTACHMENT.maxSizeInBytes = Config.ERFP_ATTACHMENT.maxSize * 1024 * 1024;
        break;
      case 'gb' : 
        Config.ERFP_ATTACHMENT.maxSizeInBytes = Config.ERFP_ATTACHMENT.maxSize * 1024 * 1024 * 1024;
        break;
      default :
        Config.ERFP_ATTACHMENT.maxSizeInBytes = Config.ERFP_ATTACHMENT.maxSize * 1024 * 1024; //based on current scenario default is 3MB
    }
  },

  /**
   * This method creates accordion for uploaded files to enter additional information about the document.
   * @event {object} click event as a parameter to perform accordion expand and collapse.
   */
  fileUploadAdditionInfo : function _fileUploadAdditionInfo(event) {
    event.stopPropagation();
    if(event.target.type === 'textarea') return;
    var _self = this, currentTarget = $(event.currentTarget);
    if(currentTarget.find('.js-comments-section').is(':visible')){
      currentTarget.find('.js-toggle-icon').removeClass('t-icon-arrow-up');
      currentTarget.find('.js-comments-section').hide();
    }else{
      _self.$el.find('.js-toggle-icon').removeClass('t-icon-arrow-up');
      _self.$el.find('.js-comments-section').hide();
      currentTarget.find('.js-toggle-icon').addClass('t-icon-arrow-up');
      currentTarget.find('.js-comments-section').toggle('is-hidden');
    }
  },

  fetchData: function _fetchData(event, element) {
    if(event) {
      event.stopPropagation();
    }
    var _self = this,
    element = event ? $(event.target) : element,
    docId = null,
    data={}, i=0, isDataFound=false;

    docId = element.data('docid');
    if(element.val()!== '') {
      data.docId = docId;
      data.description = element.val();
      
      for(i=0; i < _self.formData.length; i++ ){
        if(_self.formData[i].docId === docId){
          isDataFound = true;
          _self.formData[i].description = element.val();
          break;
        }
      }
      if(!isDataFound){
        _self.formData.push(data);
      }
    }
  },
  /**
   * This method publishes the addition information about the document with doc id to form submit tile
   * @event {object} blur event as a parameter to collect data and send as an object
   */
  sendCommentsDataForSubmit : function _sendCommentsDataForSubmit(event){
    var _self = this;
    _self.fetchData(event);
    _self.pubsub.publish('UPDATE_FORM_DATA', ['attachmentDetails', _self.formData]);
    if($('.js-attachment-descriptions').length){
      $('.js-attachment-descriptions').val(JSON.stringify(_self.formData));
    }
  },
  
  /**
   * This method will show the error message associated with file upload.
   * @param {string} it expects a string as error type to show corresponding messages
   */
  showFileErrorMessage : function _showFileErrorMessage(errorType) {
    var _self = this, errorSection = _self.$el.find('.js-error-message-cont'), errorMessageCont = errorSection.find('.js-file-error-message');
    if(_self.errorMessages[errorType]){
      errorMessageCont.text(_self.errorMessages[errorType]);
      errorSection.removeClass('is-hidden');
    }
  },

  /**
   * This method will hide the error message associated with file upload.
   */
  hideErrorMessage : function _hideErrorMessage () {
    var _self = this, errorSection = _self.$el.find('.js-error-message-cont'), errorMessageCont = errorSection.find('.js-file-error-message');
    errorMessageCont.text('');
    errorSection.addClass('is-hidden');
  },

  /**
   * This method will display the information of newly uploaded file.
   * @param {object} meta data information about the file like name size and docID etc.
   */
  addNewFileRow : function _addNewFileRow(data) {
    var _self = this, template = null, fileDetailInputField = {}, ulEle = _self.$el.find('.js-uploaded-file-list'), removelabel=ulEle.data('removefilebttn'), filedetails = data.fileDetails, maxLength = ulEle.data('detailsfieldmaxlength'), placeHolder = ulEle.data('detailsfieldplaceholder');
    filedetails.removeLabel = removelabel;
    fileDetailInputField.maxLength= maxLength;
    fileDetailInputField.placeholder = placeHolder;
    filedetails.fileDetailInputField = fileDetailInputField; 
    template = templateUploadedFileList(filedetails);
    ulEle.append(template);
    ulEle.find('li:last-child').trigger('click');
  },

  /**
   * This method will remove the attachment file
   * @event {object} click event on each file remove link.
   */
  removeAttachment : function _removeAttachment(event) {
    event.preventDefault();
    event.stopPropagation();
    var _self = this;
    var data = {};
    var ele = $(event.currentTarget);
    var docId = ele.data('docid');
    var endpointUrl = ele.parents('ul').data('removefileurl');
    var fileSize = ele.closest('li').data('filesize');

    data.docId = docId;
    data.size = fileSize;

    _self.makeAjaxCall({
      url: endpointUrl,
      method: 'POST',
      data: JSON.stringify(data),
      success: function(response) {
        if(response.success === true) {
          ele.closest('li').remove();
          if(_self.$el.data('isQuickGroupReviewFlag')) {
            _self.reviewPageAttachment();
          }
          _self.updateUploadedFileSize(fileSize);
          Config.ERFP_ATTACHMENT.uploadedFilesCount -= 1;
          if (!Config.ERFP_ATTACHMENT.uploadedFilesCount) {
            _self.enableContactInfoCTA = false;
            _self.pubsub.publish('SHOW_SKIP_TO_CONTACT_CTA', [{show: _self.enableContactInfoCTA}]);
          }
          _self.setDefaultData();
          _self.pubsub.publish('UPDATE_FORM_DATA', ['attachmentDetails', _self.formData]);
          _self.pubsub.publish('UPDATE_EVENT_SUMMARY',['attachmentDetails',{"totalFilesUploaded":Config.ERFP_ATTACHMENT.uploadedFilesCount}]);
          _self.$el.find('.js-total-file-size').text(response.totalFileSizeLabel);
          _self.enableFileUploadButton()
        }
      },
      error: function(e) {
        console.error(e)
      }
    });
  },
  /**
   * This method will disable the upload file button after successfully uploading the total number of files.
   */
  disableFileUploadBttn : function _disableFileUploadBttn () {
    var _self = this,
    fileUpload = _self.$el.find('.js-add-attachments'),
    $attachmentBttn = _self.$el.find('.js-attach-bttn');
    if(Config.ERFP_ATTACHMENT.uploadedFilesCount == Config.ERFP_ATTACHMENT.fileCount){
      fileUpload.attr('disabled', true);
      $attachmentBttn.addClass('is-disabled');
    }
  },
  /**
   * This method will enable the upload file button if any file is removed.
   */
  enableFileUploadButton : function _enableFileUploadButton() {
    var _self = this,
    fileUpload = _self.$el.find('.js-add-attachments'),
    $attachmentBttn = _self.$el.find('.js-attach-bttn');
    if(Config.ERFP_ATTACHMENT.uploadedFilesCount < Config.ERFP_ATTACHMENT.fileCount){
      fileUpload.removeAttr('disabled');
      $attachmentBttn.removeClass('is-disabled');
    }
  },

  /**
   * This method will decrease the uploaded files size - deleted file size
   */
  updateUploadedFileSize : function _updateUploadedFileSize(size) {
    Config.ERFP_ATTACHMENT.uploadedFilesSizeInBytes -= size;

  },
  // This method handles tab indexing for attachment button
  handleTabIndex: function() {
    this.$el.find('.js-add-attachments').attr('tabIndex', -1);      
    this.$el.find('.l-attach-file-bttn, .js-file-additional-info').attr('tabIndex', 0);      
  },
  // This method enables enter on label to open file input
  handleEnterOnLabel: function _handleEnterOnLabel(evt) {
    var _self = this;
    if( evt.which == 13 ) {
      _self.$el.find('.js-add-attachments').click();
    }
  }
});